import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import { Button, Segment } from "semantic-ui-react";
import axios from 'axios';

function mapStateToProps(state) {
    return {};
}

class DiagnoseConnection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            apiConnection: null,
            ip: null,
            hostname: null,
            city: null,
            region: null,
            country: null,
            postal: null,
            errorDetails: '', // state to hold error details
            isCORSIssue: false
        };
    }

    diagnoseConnection = async () => {
        const apiEndpoint = "https://insiteapi.inenco.com/api/Info/version";

        try {
            await axios.get(apiEndpoint);
            this.setState({ apiConnection: true });
        } catch (error) {
            console.error("API Connection error", error);
            if (error.message && (error.message.includes("Network Error") || (error.response && error.response.status === 0))) {
                this.setState({ isCORSIssue: true });
            }
            this.setState({ apiConnection: false, errorDetails: error.toString() }); // store error details
        }

            // JSONP request
    const script = document.createElement('script');
    const callbackName = `jsonp_callback_${Date.now()}`; // Create a unique callback name for each request

    window[callbackName] = (data) => {
        this.setState({
            region: data.region,
            ip: data.ip,
            hostname: data.hostname,
            city: data.city,
            country: data.country,
            postal: data.postal,
        });

        delete window[callbackName]; // Cleanup after the request
        document.body.removeChild(script);
    };

    script.src = `https://ipinfo.io/?callback=${callbackName}&token=b95be318ce1c8f`;
    document.body.appendChild(script);
    
    }

    render() {
        const { apiConnection, region, ip, country, city, hostname, errorDetails, isCORSIssue } = this.state;

        return (
            <div className="diagnostic">
                <Helmet>
                    <title>Inenco Portal | Connection Diagnostic</title>
                </Helmet>

                <h4>Connection Diagnostic</h4>
                <Segment>
                    <Button onClick={this.diagnoseConnection}>Diagnose</Button>
                    <div>
                        <p>API Connection: {apiConnection === true ? "Success" : (apiConnection === false ? "Fail" : "Not checked yet")}</p>
                        {isCORSIssue && <p style={{color: 'red'}}>Potential CORS issue detected. Please check server configuration or consult your IT team.</p>}
                        <p>User Region: {region || "Not checked yet"}</p>
                        <p>User Ip: {ip || "Not checked yet"}</p>
                        <p>User Country: {country || "Not checked yet"}</p>
                        <p>User City: {city || "Not checked yet"}</p>
                        <p>User Host: {hostname || "Not checked yet"}</p>
                        <p>Error Details: {errorDetails}</p> {/* Display error details */}
                    </div>
                </Segment>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
)(DiagnoseConnection);
